import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EditingState } from './editing.state';
import { Observable } from 'rxjs';
import { SetCloseResult, SetIsEditing, SetIsEditingModalOpen } from './editing.actions';

@Injectable({
  providedIn: 'root'
})
export class EditingFacade {
  private readonly store = inject(Store);

  @Select(EditingState.isEditing) isEditing$: Observable<boolean>;
  @Select(EditingState.isEditingModalOpen) isEditingModalOpen$: Observable<boolean>;
  @Select(EditingState.closeResult) closeResult$: Observable<boolean|null>;

  get isEditing(): boolean {
    return this.store.selectSnapshot(EditingState.isEditing);
  }

  get isEditingModalOpen(): boolean {
    return this.store.selectSnapshot(EditingState.isEditingModalOpen);
  }

  get closeResult(): boolean {
    return this.store.selectSnapshot(EditingState.closeResult);
  }

  setEditing(isEditing: boolean) {
    return this.store.dispatch(new SetIsEditing(isEditing));
  }

  setEditingModalOpen(isEditingModalOpen: boolean) {
    return this.store.dispatch(new SetIsEditingModalOpen(isEditingModalOpen));
  }

  setCloseResult(closeResult: boolean|null) {
    return this.store.dispatch(new SetCloseResult(closeResult));
  }
}
